import './index_mWeb.css';
import Constants from '../../constants';

interface Props {
  avatar?: string;
  score?: number;
  winner?: boolean;
  winnings?: number;
  winningType?: number;
  username?: string;
  isShowScore?: boolean;
}

const MatchMakingWinnerMWeb = ({
  avatar,
  score,
  winner,
  winnings = 0,
  winningType,
  username,
  isShowScore = false
}: Props) => {
  const winnings_ = winningType === 1 ? winnings / 100 : winnings;
  return (
    <div>
      {winner ? (
        <div className="matchMakingWinner__winnerTitle__mWeb">Winner!</div>
      ) : (
        <div className="matchMakingWinner__loserTitle__mWeb">Loser!</div>
      )}
      <div className={'matchMakingWinner__avatarContainer__mWeb'}>
        <img
          className={'matchMakingWinner__avatarFrame__mWeb '}
          src={Constants.Images.MatchMakingAvatarFrame}
        />
        <img className={'matchMakingWinner__avatarImg__mWeb '} src={avatar} />
      </div>
      {winner ? (
        <div className="matchMakingWinner__winnerStrapWrapper__mWeb">
          <img
            className={'matchMakingWinner__winnerStrap__mWeb '}
            src={Constants.Images.MatchMakingWinnerStrap}
          />
          <div className={'matchMakingWinner__avatarName__mWeb '}>{username}</div>
        </div>
      ) : (
        <div className="matchMakingWinner__loserStrapWrapper__mWeb">
          <img
            className={'matchMakingWinner__loserStrap__mWeb '}
            src={Constants.Images.MatchMakingLoserStrap}
          />
          <div className={'matchMakingWinner__avatarName__mWeb '}>{username}</div>
        </div>
      )}
      <div
        className="matchMakingWinner__scoreMainContainer__web"
        style={{
          justifyContent: isShowScore ? 'space-between' : 'center'
        }}>
        {isShowScore && (
          <div className="matchMakingWinner__scoreWrapper__mWeb">
            <div className={'matchMakingWinner__scoreLabel__mWeb '}>{`Score`}</div>
            <div className={'matchMakingWinner__score__mWeb '}>{score}</div>
          </div>
        )}
        <div className="matchMakingWinner__scoreContainer__mWeb">
          {winningType === 1 ? (
            <div className="matchMakingWinner__scoreWrapper__mWeb">
              <div className="matchMakingWinner__scoreLabel__mWeb">Cash</div>
              <div className="matchMakingWinner__winningsWrapper__mWeb">
                <img className="matchMakingWinner__cashImg__mWeb" src={Constants.Images.coin}></img>
                <div className={'matchMakingWinner__winnings__mWeb '}>{`${winnings_}`}</div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
export default MatchMakingWinnerMWeb;
